'use strict';

module.exports = require('./lib/parser');




//////////////////
// WEBPACK FOOTER
// ./~/rss-parser/index.js
// module id = 1567
// module chunks = 0